// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2_zAY","header":"styles_header__3KdTZ","title":"styles_title__VkUKN","tableHeader":"styles_tableHeader__3Vv9-"};